import React, { useEffect, useLayoutEffect, useState } from 'react'
import { AppBar, Box, Button, IconButton, Toolbar, } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import LaunchIcon from '@mui/icons-material/Launch';
import SearchIcon from '@mui/icons-material/Search';
import SiteSearch from '../modules/SiteSearch';
import MenuMain from '../modules/MenuMain';
import HeaderLogo from '../submodules/HeaderLogo';
import HeaderButtonForBusiness from '../submodules/HeaderButtonForBusiness';

const Header = (props) => {

  
  const [ isAppBarHovered, setIsAppBarHovered ] = useState(false);
  const [ isMobile, setIsMobile ] = useState(window.innerWidth <= 720);
  const [ isTablet, setIsTablet ] = useState(window.innerWidth <= 1164);
  const [ isSearchVisible, setIsSearchVisible ] = useState(false);
  const transitionRule = "100ms ease all";


  // Use the useEffect hook to update the isMobile & isTabletd state when the window is resized
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 720); // Adjust the screen width threshold
      setIsTablet(window.innerWidth <= 1164); // Adjust the screen width threshold
    }

    window.addEventListener('resize', handleResize);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // defines a fucntion to check if the screen is small, and if so, closes the site search component.
  useLayoutEffect(() => {

    const handleAutoSearchClose = () => {
      if (isMobile) {
        setIsSearchVisible(false);
      } else return;
    }
    handleAutoSearchClose();

    return () => { 
      if (process.env.NODE_ENV === 'development') {
        console.log("Clean up for isMobile");
      }
    }

  }, [isMobile])

  // AppBar Hover Handlers
  const handleAppBarMouseOut = () => {
    setIsAppBarHovered(false);
  }
  const handleAppBarMouseOver = () => {
    setIsAppBarHovered(true);
  };

  return (
    <AppBar
      position="sticky"
      onMouseOut={handleAppBarMouseOut}
      onMouseOver={handleAppBarMouseOver}
      sx={{ backgroundColor: !isAppBarHovered ? "default" : "#ffffff", transition: transitionRule, }}
    >
      <Toolbar>
        {/* AppBar Left */}
        <HeaderLogo isAppBarHovered={isAppBarHovered} isMobile={isMobile} isTablet={isTablet} />
        <MenuMain isAppBarHovered={isAppBarHovered} isMobile={isMobile} isTablet={isTablet} />
        <Box sx={{alignItems: "center", display: "flex", flexDirection: "row",}}>
          {
            !isTablet ? (
              <>
                <Button
                  aria-label="Resources"
                  href="/resources/"
                  sx={{color: !isAppBarHovered ? "#fff" : "initial", mx: 1, transition: transitionRule}}
                >
                  Resources
                </Button>
                <Button
                  aria-label="Gallery"
                  href="/gallery/"
                  sx={{color: !isAppBarHovered ? "#fff" : "initial", mx: 1, transition: transitionRule}}
                >
                  Gallery
                </Button>
                <Button
                  aria-label="Pricing"
                  href="/pro/"
                  sx={{color: !isAppBarHovered ? "#fff" : "initial", mx: 1, transition: transitionRule}}
                >
                  Pricing
                </Button>
                <Box sx={{mx: 1,}}>
                  {
                    isAppBarHovered ?
                      <HeaderButtonForBusiness /> :
                      <Button
                        aria-label="Resources"
                        href="/business/"
                        sx={{color: "#fff", fontStyle: "italic", mode: "contained"}}
                      >
                        For Business
                      </Button>
                  }
                </Box>
              </>
            ) : null
          }
        </Box>
        {/* AppBar Spacing */}
        <Box sx={{display: "flex", flex: 1,}}></Box>
        {/* AppBar Right */}
        {
          !isSearchVisible ? (
            !isTablet ? (
            <Button
              aria-label="Launch Designer"
              href="https://designer.personalarch.com/"
              sx={{color: !isAppBarHovered ? "#fff" : "initial", mx: 1, transition: transitionRule}}
            >
                Launch Designer
            </Button>
            ) : (
              <IconButton
                aria-label="Launch Designer"
                href="https://designer.personalarch.com/"
                sx={{color: !isAppBarHovered ? "#fff" : "initial",}}
              >
                <LaunchIcon />
              </IconButton>
            )
          ) : null
        }
            <>
              {
                isSearchVisible ? (
                  <Box sx={{marginLeft: 2,}}>
                    <SiteSearch isAppBarHovered={isAppBarHovered} isMobile={isMobile} />
                  </Box>
                ) : null
              }
              <IconButton
                aria-label="Search"
                onClick={() => { setIsSearchVisible(!isSearchVisible) }} sx={{ml:1,}}
              >
                {
                  isSearchVisible ? (
                    <CloseIcon color={!isAppBarHovered ? "white" : "black"} />
                    ) : (
                    <SearchIcon color={!isAppBarHovered ? "white" : "black"} />
                  )
                }
              </IconButton>
            </>
      </Toolbar>
    </AppBar>
  )
}

export default Header
